import { Card, Tag, Popconfirm,message } from "antd";
import {
    FileTextOutlined, DeleteOutlined
} from "@ant-design/icons";
import BackButton from "../../components/CustomButton/BackButton";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getIdQuestionnaireThread, deleteThreadQuestion } from "../../redux/slices/QuestionBankSlice";
import "./EnqMngt.scss";


const QuestionnaireThread = () => {
    const { idQuestionnaireThread } = useSelector((state) => state.questionBank);
    const navigate = useNavigate();
    const { threadId, orgId } = useParams();
    const dispatch = useDispatch();


    useEffect(() => {
        if (threadId) {
            dispatch(getIdQuestionnaireThread(threadId));
        }
    }, [dispatch, threadId]);

   const handleDelete = async (questionId) => {
    const totalQuestions = idQuestionnaireThread?.questions?.length || 0;

    const res = await dispatch(deleteThreadQuestion({ questionId, threadId }));

    if (res.payload.statusCode === 200) {
        message.success("Question deleted successfully");

        if (totalQuestions > 1) {
            // Multiple questions → refresh thread
            dispatch(getIdQuestionnaireThread(threadId));
        } else {
            // Only one question → navigate
            navigate(`/enquiry-management/send-questionnaire/${orgId}`);
        }
    }
};

    return (
        <div className="thread-container">
            {/* Header */}
            <div className="thread-header">
                <BackButton onClick={() => navigate(-1)}>
                    ← Back to Business Details
                </BackButton>

                <div className="thread-title">
                    {/* <h3>{orgId}</h3> */}
                    <p>Questionnaire Thread • {idQuestionnaireThread?.questions?.length || 0} questions</p>
                </div>

                <Tag color="orange">{idQuestionnaireThread?.status}</Tag>
            </div>

            {/* Questionnaire Box */}
            <Card className="questionnaire-box">
                <div className="questionnaire-title">
                    <FileTextOutlined />
                    <span>{idQuestionnaireThread?.threadName} ({idQuestionnaireThread?.questions?.length || 0} questions)</span>
                </div>

                {idQuestionnaireThread?.questions?.map((q, index) => (
                    <div key={q.questionId} className="question-item">
                        <div className="question-row">
                            <p className="q-label">Q{index + 1}.</p>
                            <p className="q-title">{q.questionDetails?.questionTitle}</p>
                            {/* <Popconfirm
                                title="Delete Question"
                                description="Are you sure to delete this question?"
                                onConfirm={() => handleDelete(q.questionId)}
                                okText="Yes"
                                cancelText="No"
                            >
                                <DeleteOutlined
                                    className="delete-icon"
                                />
                            </Popconfirm> */}
                                <Popconfirm
                                    title="Delete Question"
                                    description="Are you sure to delete this question?"
                                    onConfirm={() => handleDelete(q.questionId)}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <DeleteOutlined
                                        className="delete-icon"
                                    />
                                </Popconfirm>
                             {/* )} */}
                        </div>
                    </div>
                ))}
            </Card>
        </div>
    );
};

export default QuestionnaireThread;